import { usePasswordActions } from "store/ResetPasswordSlice";

const usePassword = () => {
  const { sendEmail, update } = usePasswordActions();

  return { sendEmail, update };
};

export default usePassword;
